import { render } from "./AboutSection.vue?vue&type=template&id=c89117fa&scoped=true"
const script = {}

import "./AboutSection.vue?vue&type=style&index=0&id=c89117fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c89117fa"]])

export default __exports__